/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';

import CasinoCRMApi from '../../../../casino/Api/CRM/CasinoCRMApi';
import BonusSummaryResponse from '../../../../casino/Api/CRM/Responses/BonusSummaryResponse';
import Loader from '../../../elements/Loader';

interface Props {
    bonusId: number;
    bonusType: string;
}

export default function BonusSummary({ bonusId, bonusType }: Props) {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [summary, setSummary] = useState<BonusSummaryResponse>({
        number_of_activations: 0,
        currently_activated_for: 0,
        amount_of_received_prizes: 0,
        count_of_users_that_filled_requirements: 0,
        count_of_users_that_received_prize: 0,
    });

    async function loadState() {
        setSummary(await CasinoCRMApi.bonuses.getBonusSummary(bonusId, bonusType));
    }

    useEffect(() => {
        setIsLoading(true);
        loadState();
        setIsLoading(false);
    }, []);

    const getContent = () => {
        return (
            <div>
                <div className="card-header">Summary</div>
                <div className="card-body table-responsive">
                    <table className="table table-show">
                        <thead />
                        <tbody>
                            <tr>
                                <th>Number of activations</th>
                                <td>{summary.number_of_activations ?? 0}</td>
                            </tr>
                            <tr>
                                <th>Currently activated for</th>
                                <td>{summary.currently_activated_for ?? 0} user(s)</td>
                            </tr>
                            <tr>
                                <th>Amount of received prizes</th>
                                <td>
                                    {summary.amount_of_received_prizes ?? 0} {process.env.MIX_CURRENCY}
                                </td>
                            </tr>
                            <tr>
                                <th>Count of users that filled requirements</th>
                                <td>{summary.count_of_users_that_filled_requirements ?? 0}</td>
                            </tr>
                            <tr>
                                <th>Count of users that received prize</th>
                                <td>{summary.count_of_users_that_received_prize ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    return <Loader loading={isLoading} content={getContent} />;
}
